import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

const FormTableToolbar = ({ className, ...rest }) => {
  return <div className={classNames('form-table-toolbar', className)} {...rest} />;
};

FormTableToolbar.defaultProps = {
  className: '',
};

FormTableToolbar.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
};

export default FormTableToolbar;
